import React from "react";
import { BsBoxArrowUpRight } from "react-icons/bs";

function ProjectItem(props) {
	const handleLinkClick = () => {
		window.open(props.link, "_blank");
	};

	return (
		<>
			<li className="projects_item">
				<div className="projects_item_link">
					<figure
						className="projects_item_pic-wrap"
						onMouseEnter={props.handleMouseEnter}
						onMouseLeave={props.handleMouseLeave}
					>
						<img
							src={props.src}
							alt={props.text}
							className="projects_item_img"
							onClick={props.handleInfoClick}
						/>
					</figure>
					<div className="projects_item_info">
						<h5 className="projects_item_text" onClick={handleLinkClick}>
							<span>{props.text}</span>
							<BsBoxArrowUpRight className="projects_item_open_icon" />
						</h5>
					</div>
				</div>
			</li>
		</>
	);
}

export default ProjectItem;
